window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {

  var newAddressForm = document.getElementById('AddressNewForm');
  var newAddressFormButton = document.getElementById('AddressNewButton');

  if (!newAddressForm) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
    );
  }

  // Initialize each edit form's country/province selector
  document
      .querySelectorAll('.address-country-option')
      .forEach(function (option) {
        var formId = option.dataset.formId;
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

  // Toggle new/edit address forms
  document.querySelectorAll('.address-new-toggle').forEach(function (button) {
    button.addEventListener('click', function () {
      var isExpanded =
          newAddressFormButton.getAttribute('aria-expanded') === 'true';

      newAddressForm.classList.toggle('hide');
      newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
      newAddressFormButton.focus();
    });
  });

  document.querySelectorAll('.address-edit-toggle').forEach(function (button) {
    button.addEventListener('click', function (evt) {
      var formId = evt.target.dataset.formId;
      var editButton = document.getElementById('EditFormButton_' + formId);
      var editAddress = document.getElementById('EditAddress_' + formId);
      var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

      editAddress.classList.toggle('hide');
      editButton.setAttribute('aria-expanded', !isExpanded);
      editButton.focus();
    });
  });

  document.querySelectorAll('.address-delete').forEach(function (button) {
    button.addEventListener('click', function (evt) {
      var target = evt.target.dataset.target;
      var confirmMessage = evt.target.dataset.confirmMessage;

      // eslint-disable-next-line no-alert
      if (
          confirm(
              confirmMessage || 'Are you sure you wish to delete this address?'
          )
      ) {
        Shopify.postLink(target, {
          parameters: {_method: 'delete'}
        });
      }
    });
  });

})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.ariaToggle = function() {
  $(document).on('click', '.ariaToggle', function(event){
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    var toggleID = $currentTarget.attr('aria-controls');
    $( '#'+ toggleID ).toggleClass('expanded');
  });
};

theme.ariaToggleSlide = function() {
  $(document).on('click', '.ariaToggleSlide', function(event){
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    var toggleID = $currentTarget.attr('aria-controls');
    $( '#'+ toggleID ).slideToggle();
  });
};

theme.ariaToggleSlideChangeButton = function() {
  $(document).on('click', '.ariaToggleSlideChangeButton', function(event){
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    $currentTarget.find('span:first-child').text($currentTarget.find('span:first-child').text()==$currentTarget.attr('data-close-label') ? $currentTarget.attr('data-open-label') : $currentTarget.attr('data-close-label'));
    var toggleID = $currentTarget.attr('aria-controls');
    $( '#'+ toggleID ).slideToggle();
  });
};

theme.ariaToggleOneSlide = function() {
  $(document).on('click', '.ariaToggleOneSlide', function(event){
    event.preventDefault();
    $(this).closest('div').siblings().find('button.ariaToggleOneSlide').attr('aria-expanded', 'false').next(':not(.global-sidebar)').slideUp();
    $(this).attr('aria-expanded', $(this).attr('aria-expanded')=='false' ? 'true' : 'false').next(':not(.global-sidebar)').slideToggle();
  });
};

theme.smoothScroll = function() {
  $(document).on('click', 'a[href*="#"]:not([href="#"]), a[href*="/#"]:not([href="/#"]), a[href*="/pages/juvias-skin#"]:not([href="/pages/juvias-skin#"])', function(event) {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
      var height = parseInt($(this).attr('data-additional-height')) ? parseInt($(this).attr('data-additional-height')) : 0;
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length && target.is(':visible')) {
        event.preventDefault();
        $('html,body').animate({
          scrollTop: target.offset().top - height
        }, 1000);
      }
    }
  });
};

theme.outlineNone = function() {
  var body = $('body');

  $(document).on('click', function () {
    if (!body.hasClass('outline-none')) {
      body.addClass('outline-none');
    }
  });

  $(document).on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;

    if (body.hasClass('outline-none') && keyCode == 9) {
      body.removeClass('outline-none');
    }
  });
};

theme.GlobalCssVariables = function() {
  function setValues() {
    const headerHeight = document.querySelector('.header')?.getBoundingClientRect().height;
    const headerInnerHeight = document.querySelector('.header-inner')?.getBoundingClientRect().height || 0;
    const switchNavHeight = document.querySelector('.header-site-switch')?.getBoundingClientRect().height || 0;
    const navHeight = document.querySelector('.header-menu:not(.header-site-switch)')?.getBoundingClientRect().height || 0;
    const headerPromoBar = document.querySelector('.promo-bar__content')?.getBoundingClientRect().height;
    const headerPromo = document.querySelector('.promo-bar')?.getBoundingClientRect().height;
    const mobileRecCollectionsSelector = document.querySelector('.mobile-rec-collections')
    let mobileRecCollections
    let promoDifferentHeight = 0;

    if (mobileRecCollectionsSelector) {
      if (window.innerWidth < 990) {
        mobileRecCollections = mobileRecCollectionsSelector?.getBoundingClientRect().height || 154
      } else {
        mobileRecCollections = mobileRecCollectionsSelector?.getBoundingClientRect().height || 0
      }
    }
    
    document.documentElement.style.setProperty('--mobile-rec-collections', mobileRecCollections + 'px');
    document.documentElement.style.setProperty('--switch-nav-height', switchNavHeight + 'px');
    document.documentElement.style.setProperty('--header-height', headerHeight + mobileRecCollections + headerPromo + 'px');
    document.documentElement.style.setProperty('--sticky-header-height', switchNavHeight + navHeight + mobileRecCollections + 'px');
    document.documentElement.style.setProperty('--header-inner-height', headerInnerHeight + 'px');
    document.documentElement.style.setProperty('--nav-height', navHeight + 'px');
  
    if (headerPromoBar) {
      if ($(window).scrollTop() < headerPromoBar) {
        promoDifferentHeight = headerPromoBar - $(window).scrollTop();
      }

      document.documentElement.style.setProperty('--promo-bar-height', headerPromoBar + 'px');
      document.documentElement.style.setProperty('--mobile-sidebar-top',  headerInnerHeight + promoDifferentHeight  + 'px');
    } else {
      document.documentElement.style.setProperty('--promo-bar-height', 0 + 'px');
      document.documentElement.style.setProperty('--mobile-sidebar-top',  headerInnerHeight + 'px')
    }

    if (headerPromo) {
      document.documentElement.style
        .setProperty('--promo-height', headerPromo + 'px');
    } else {
      document.documentElement.style.setProperty('--promo-height', 0 + 'px');
    }
  }

  $( window ).on('load resize orientationchange', $.debounce(200, function () {
    setValues();
  }));
};

theme.GlobalSidebar = function() {
  var $buttonModal = '.global-sidebar-button[aria-controls]';

  $(document).on('click', '.close', function () {
    var id = $(this).parents('.global-sidebar').attr('id');

    closeSidebar(id);
  });

  $(document).on('click', $buttonModal, function (e) {
    e.preventDefault();
    var thisId = $(this).attr('aria-controls');

    openSidebar(thisId);
  });

  $(document).mouseup(function (e){
    var divAfterpay = $('afterpay-modal[visible="visible"]');
    var div = $('.global-sidebar[aria-hidden="false"]');
    var divChild = div.find('.insert[aria-hidden="false"]');

    if (!div.is(e.target)
      && div.has(e.target).length === 0
      && !divChild.is(e.target)
      && divChild.has(e.target).length === 0
      && !divAfterpay.is(e.target)
      && divAfterpay.has(e.target).length === 0) {
      closeSidebar();
    }
  });

  $( window ).on('orientationchange', function () {
    closeSidebar();
  });

  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      closeSidebar();
    }
  });


  $(window).on('resize', function () {
    $('.global-sidebar[aria-hidden="false"]').css('height', window.innerHeight);
  });

  function openSidebar(id) {
    var thisHeight;
    var thisModal = $('#' + id);
    var thisModalHeight = thisModal.outerHeight();
    var topBarHeight = $( '.announcement-bar' ).outerHeight();
    var headerHeight = thisModal.children('.global-sidebar__header').outerHeight();
    var $popoverContainer = $('.global-sidebar__wrapper');
    var scrolled = $( window ).scrollTop();
    var topBarHeightNoSticky = topBarHeight - scrolled;

    if (topBarHeightNoSticky < 0) {
      topBarHeightNoSticky = 0;
    }

    if (!thisModal) {
      return;
    }

    bodyScrollLock.clearAllBodyScrollLocks();
    bodyScrollLock.disableBodyScroll(thisModal.find('.global-sidebar__wrapper')[0]);

    $( window ).on('orientationchange', function () {
      thisModalHeight = thisModal.outerHeight();
      topBarHeight = $( '.announcement-bar' ).outerHeight();
      headerHeight = thisModal.children('.global-sidebar__header').outerHeight();

      if (topBarHeight) {
        thisHeight = thisModalHeight -  headerHeight - topBarHeight;
      } else thisHeight = thisModalHeight -  headerHeight;

      $popoverContainer.css('height', thisHeight );
    });

    $(window).on('resize', function () {
      thisModalHeight = thisModal.outerHeight();
      topBarHeight = $( '.announcement-bar' ).outerHeight();
      headerHeight = thisModal.children('.global-sidebar__header').outerHeight();

      if (topBarHeight) {
        thisHeight = thisModalHeight -  headerHeight - topBarHeight;
      } else thisHeight = thisModalHeight -  headerHeight;

      $popoverContainer.css('height', thisHeight );
    });

    if (topBarHeight) {
      if (thisModal.parents('.global-sidebar').length) {
        thisModal.css('top', 0);
      } else {
        thisModal.css('top', topBarHeightNoSticky);
      }
      thisHeight = thisModalHeight -  headerHeight - topBarHeight;
    } else thisHeight = thisModalHeight -  headerHeight;

    thisModal.attr('aria-hidden', 'false');
    $popoverContainer.css('height', thisHeight );
    thisModal.css('height', window.innerHeight);
    $('body').addClass('global_sidebar--open');
    $('html').addClass('global_sidebar--open');
    $('.header').addClass('global_sidebar--open');
  }

  function closeSidebar(id) {
    var thisModal;

    if (!$('html').hasClass('global_sidebar--open')) {
      return
    }

    if (id) {
      thisModal = $('.global-sidebar[id="' + id + '"]');
    } else {
      thisModal = $('.global-sidebar[aria-hidden="false"]');
    }

    thisModal.attr('aria-hidden', 'true');
    thisModal.css('height', '');
    if (!thisModal.parents('.global-sidebar').length) {
      $('body').removeClass('global_sidebar--open');
      $('html').removeClass('global_sidebar--open');
      $('.header').removeClass('global_sidebar--open');
    } else if (id == undefined && thisModal.parents('.global-sidebar').length) {
      $('body').removeClass('global_sidebar--open');
      $('html').removeClass('global_sidebar--open');
      $('.header').removeClass('global_sidebar--open');
    }

    if ($('.global-sidebar[aria-hidden="false"]').length) {
      bodyScrollLock.clearAllBodyScrollLocks();
      bodyScrollLock.disableBodyScroll($('.global-sidebar[aria-hidden="false"]').find('.global-sidebar__wrapper')[0]);
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  }
};

theme.videoPopup = function () {
  var $videoPopup = $('.video-popup');
  var $videoPopupInner = $('.video-popup__inner');
  var $videoPopupWrapper = $videoPopup.find('.video-popup__video');
  var $$videoPopupClose = $videoPopup.find('.icon-close');
  var videoPopupActiveClass = 'open';

  $(document).mouseup(function(e) {
    if (!$videoPopupInner.is(e.target) && $videoPopupInner.has(e.target).length === 0) {
      closeModal();
    }
  });

  $$videoPopupClose.on('click', function () {
    closeModal();
  });

  $('a.video-play[href*="youtube"], a.video-play[href*="youtu"], a.video-play[href*="vimeo"], a.video-play[href*="mp4"]').on('click', function (evt) {
    evt.preventDefault();
    var url = evt.currentTarget.href;
    var src;
    var videoId;
    var allow;
    var autoplay = '?autoplay=1';

    if (url.indexOf('youtube') !== -1 || url.indexOf('youtu') !== -1) {
      if (url.indexOf('v=') !== -1) {
        videoId = url.split('v=');
        src = 'https://www.youtube.com/embed/' + videoId[1] + autoplay;
        allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay;';
      } else {
        videoId = url.split('youtu.be/');
        src = 'https://www.youtube.com/embed/' + videoId[1] + autoplay;
        allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay;';
      }

      appendIframe(src, allow);

    } else if (url.indexOf('vimeo') !== -1) {

      videoId = url.split('vimeo.com')
      src = 'https://player.vimeo.com/video' + videoId[1] + autoplay;
      allow = 'fullscreen; autoplay;';

      appendIframe(src, allow);
    } else if (url.indexOf('mp4') !== -1) {
      appendVideo(url, 'video/mp4');
    }
  });

  function openModal() {
    $videoPopup.fadeIn().addClass(videoPopupActiveClass);
  }

  function appendIframe(src, allow) {
    var iframe = '<iframe width="100%" height="auto" src="'+ src +'" frameborder="0" allow="'+ allow +'" allowfullscreen></iframe>'

    $videoPopupWrapper.html(iframe);

    openModal();
  }

  function appendVideo(src, type) {
    var video = '<video playsinline autoplay controls>' +
      '<source src="'+ src +'" type="'+ type +'">' +
      'Your browser does not support the video tag.' +
      '</video>'

    $videoPopupWrapper.html(video);

    openModal();
  }

  function closeModal() {
    $videoPopup.fadeOut().removeClass(videoPopupActiveClass);
    $videoPopupWrapper.html('');
  }
};

theme.quantitySelectors = function() {
  // Setup listeners to add/subtract from the input
  $('.js-qty__adjust').off().on('click keyup', function(e) {
    if ( e.type === 'keyup' && e.keyCode !== 13 ) return;

    var el = $(this),
      qtySelector = el.siblings('.js-qty__num'),
      qty = parseInt(qtySelector.val().replace(/\D/g, ''));

    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 0) qty = 1;
    }
    // Update the input's number
    qtySelector.val(qty).trigger('change');
  });

  // All quantity input value change on up/down arrows key press
  $('.js-qty__num')
    .off( 'keyup' )
    .on('keyup', function(e) {
      // On arrow up key press (38)
      if ( e.keyCode == 38 ) {
        $(this).siblings( '.js-qty__adjust--plus' ).trigger( 'click' );
      }
      // On arrow down key press (40)
      if ( e.keyCode == 40 ) {
        $(this).siblings( '.js-qty__adjust--minus' ).trigger( 'click' );
      }
    });
};

theme.notifyMe = function() {
  $(document).on('click', '.product-item__btn-notify', function (evt) {
    evt.preventDefault();
    
    $(this).parents('.product-btn__wrapper').find('.product-item__notify').slideToggle('400');
  });
  
  $(document).on('click', 'button[data-klaviyo-list-id]', function (evt) {
    evt.preventDefault();
    const listID = $(this).attr('data-klaviyo-list-id');
    const productId = $(this).parents('[data-bis-product-id]').attr('data-bis-product-id');
    const variantId = $(this).parents('.product-item--js').find('select[name="id"]').val();
    
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    
    var $notifyContainer = $(this).parents('.product-item__notify');
    var email = $notifyContainer.find('[name="email"]').val();
    var origin = '';
    var data = {
      'a': listID,
      'email': email,
      '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
      'variant': variantId,
      'product': productId,
      'platform': 'shopify'
    };
    
    var $emailInvalid = $notifyContainer.find('.product-item__notify-email-invalid');
    var $klaviyoError = $notifyContainer.find('.product-item__notify-klaviyo-error');
    var $subscription = $notifyContainer.find('.product-item__notify-subscription');
    
    $emailInvalid.slideUp();
    $klaviyoError.slideUp();
    $subscription.slideUp();
    
    if (!validateEmail(email)) {
      $emailInvalid.slideDown();
      return
    }
    
    $.ajax({
      method: 'POST',
      url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      data: data
    }).done(function (response) {
      if (response.success) {
        $subscription.slideDown();
      } else {
        console.error('Error Klaviyo: ', response.errors);
        $klaviyoError.slideDown();
      }
    }).fail(function (err) {
      $klaviyoError.slideDown();
    });
  });
}

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init: init
  };
})();

theme.trackingPixels = function() {
  if(theme.templateName === 'product') {
    gtag('event', 'conversion', {'send_to': 'AW-993048701/7o-ZCPS4or4DEP3wwtkD'});
  }
  
  $(document).on('click', '[data-pixel-tracking-trigger]', function(e) {
    const targetId = $(this).attr('data-pixel-tracking-trigger');
    const objectTarget = $(`[data-pixel-tracking-target="${targetId}"]`);
    
    if(!objectTarget || !objectTarget[0]) return;
    
    const dataObject = JSON.parse($(objectTarget[0]).text());
    
    gtag('event', 'conversion', dataObject);
  });
  
  $(document).on('click', '#quiz-kit-intro-button', function() {
    gtag('event', 'conversion', {
      "send_to": "AW-993048701/_7puCO65174DEP3wwtkD"
    });
  });
}

theme.textTruncate = function() {
  /*
  * - [data-truncated-text]
  * - - [data-truncate-button]
  * - [data-full-text]
  * */
  $(document).on('click', '[data-truncate-button]', function() {
    const parent = $(this).parents('[data-truncated-text]');
    const grandParent = $(parent).parent();
    const truncatedText = grandParent.find('[data-truncated-text]');
    const fullText = grandParent.find('[data-full-text]');
    
    $(this).hide();
    $(truncatedText).hide();
    $(fullText).show();
  })
}

theme.ariaTabs = function() {
  $(document).on('click', '[role="tab"]', function(e) {
    e.preventDefault();
    const tabsContainer = $(this).parents('[role="tablist"]');
    const target = $(this).attr('aria-controls');
    const parent = tabsContainer.parent();
    const grandParent = parent.parent();
    const targetTabpanel = $(`#${target}`, grandParent);
  
    $('[role="tab"]', tabsContainer).attr('aria-selected', false);
    $('[role="tab"]', tabsContainer).attr('tabindex', '-1');
    $('[role="tab"]', tabsContainer).removeClass('current');
    
    $(this).attr('aria-selected', true);
    $(this).attr('tabindex', '0');
    $(this).addClass('current');
    
    $('[role="tabpanel"]:not(.slick-slide)', grandParent).attr('hidden', '');
    $('[role="tabpanel"]:not(.slick-slide) [role="tabpanel"]:not(.slick-slide):first-child', grandParent).removeAttr('hidden');
    targetTabpanel.removeAttr('hidden');
    
    $('.slick-slider', targetTabpanel).slick('refresh');
  })
}

theme.init = function () {
  theme.videoPopup();
  theme.ariaToggle();
  theme.ariaToggleSlide();
  theme.ariaToggleSlideChangeButton();
  theme.ariaToggleOneSlide();
  theme.smoothScroll();
  theme.outlineNone();
  theme.GlobalCssVariables();
  theme.GlobalSidebar();
  theme.notifyMe();
  theme.trackingPixels();
  theme.FormStatus.init();
  theme.textTruncate();
  theme.ariaTabs();
};

$(document).ready(function() {
  $(theme.init);
});


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    //click listener need for firefox
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      // if (variant.available) {
      //   if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //     return;
      //   }
      // }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
theme.CountryCodeFilter = (function() {

  function CountryCodeFilter(container) {
    this.$container = $(container);

    var country = sessionStorage.getItem("userCountryIsoCode");

    if (!country) {return false}
    var slideshow = this.$container.find('[data-section-type="slideshow"]');

    if (slideshow.length && slideshow.hasClass('slick-initialized')) {
      slideshow.trigger('filterSlideshowByCountry');
    } else {
      var elements = this.$container.find(`[data-country-filter]:not([data-country-filter="all"], [data-country-filter~="${country.toLowerCase()}"])`);
      elements.remove();
    }
  }

  return CountryCodeFilter;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Cart = (function() {
  function Cart(container) {
    this.$container = $(container);
    var removeSelector = '[data-action="update-item-quantity"], [data-action="remove-item"]';
    var quickAdd = '[data-action="quick-add-to-cart"]';
    var quickAddFormSerialize = 'input[type="submit"].shade_atc';
    var quantitySelector = '.quantity-selector__current-quantity';
    var openCartDrawerSelector = '[data-open-cart-drawer]';
    var closeCartDrawerSelector = '.close-cart-drawer';
    var subscriptionSelect = '[data-subscription-select]';

    $(window).on('load', function() {
      setTimeout(function(){
        window.loaded = true;
      }, 0);
    });

    $(document).on('click', openCartDrawerSelector, this.renderCart.bind(this));
    $(document).on('click', closeCartDrawerSelector, this.closeSidebar);
    $(document).on('click', quickAdd, this.quickAddToCart.bind(this));
    $(document).on('click', quickAddFormSerialize, this.quickAddToCartFormSerialize.bind(this));
    $(document).on('click', removeSelector, this.updateItemQuantity.bind(this));
    $(document).on('change', quantitySelector, this.updateItemQuantity.bind(this));
    $(document).on('change', subscriptionSelect, this.subscriptionChange.bind(this));
    $(document).on('product:added', this.onProductAdded.bind(this));
    
    $(window).on('resize', function () {
      document.documentElement.style.setProperty('--drawer-header-height', $('#sidebar-cart .cart-drawer__header').outerHeight() + 'px');
    });

    this.promoCodeTracking();
    this.clickGwpButtons();
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    updateItemQuantity: function (event) {
      event.preventDefault();
      
      var quantity = null,
        _this = this,
        elementToAnimate = null;
      
      if (event.target.nodeName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(event.target.value) || 1, 1));
      } else {
        quantity = parseInt(event.target.getAttribute('data-quantity'));
      }
      
      // If the quantity is 0, then we will animate the product with a removal effect
      if (quantity === 0) {
        elementToAnimate = event.target.closest('.cart-item');
      }
      
      fetch("/cart/change.js", {
        body: JSON.stringify({ id: event.target.getAttribute('data-line-id'), quantity: quantity }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        _this.renderCart()
      });
    },
  
    renderCart: function (evt) {
      if (evt) {
        evt.preventDefault();
      }

      var _this33 = this;
      
      fetch('/cart?view=drawer' + '&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        content.text().then(function (html) {
          var cartAttr = $(html).find('[data-cart-attr]').length ? JSON.parse($(html).find('[data-cart-attr]').html()) : false;
          var count = parseInt($(html).find('.cart-drawer__item-counts').attr('data-count'));
          var gwpSelectedProduct = $(html).find('.Cart__FreeShipping[data-selected-gwp-id]').attr('data-selected-gwp-id');
          var gwpSelectedEvent = $(html).find('.Cart__FreeShipping[data-selected-gwp-id]').attr('data-selected-gift');
          var $gwpSelectedProductsDelete = $(html).find('[data-selected-gwp-products-delete]');
          var gwpSelectedProductsDeleteAll = $gwpSelectedProductsDelete.attr('data-selected-gwp-products-delete-all') == 'true' ? true : false;
          var gwpSelectedProductsIdsInCart = $gwpSelectedProductsDelete.length ? JSON.parse($gwpSelectedProductsDelete.html()) : false;
          var gwpSelectedProductsIdData = {};
          var layoutType = $('html').attr('data-layout');

          var tieredGwpData = {};
          var tieredGwp = $(html).find('[data-tiered-gwp]');
          var tieredGwpAction1 =  tieredGwp.attr('data-tiered-gwp-1') != '' ? (tieredGwp.attr('data-tiered-gwp-1') == 'add' ? 1 : 0) : false;
          var tieredGwpId1 = tieredGwp.attr('data-tiered-gwp-product-1') || false;
          var tieredGwpAction2 =  tieredGwp.attr('data-tiered-gwp-2') != '' ? (tieredGwp.attr('data-tiered-gwp-2') == 'add' ? 1 : 0) : false;
          var tieredGwpId2_1 = tieredGwp.attr('data-tiered-gwp-product-2-1') || false;
          var tieredGwpId2_2 = tieredGwp.attr('data-tiered-gwp-product-2-2') || false;
          var tieredGwpAction3 = tieredGwp.attr('data-tiered-gwp-3') != '' ? (tieredGwp.attr('data-tiered-gwp-3') == 'add' ? 1 : 0) : false;
          var tieredGwpId3_1 = tieredGwp.attr('data-tiered-gwp-product-3-1') || false;
          var tieredGwpId3_2 = tieredGwp.attr('data-tiered-gwp-product-3-2') || false;
          var tieredGwpId3_3 = tieredGwp.attr('data-tiered-gwp-product-3-3') || false;
          var tieredGwpsAll = tieredGwp.attr('data-tiered-gwp-all') != '' ? JSON.parse(tieredGwp.attr('data-tiered-gwp-all')) : false;
          var tieredGwpsAllDelete = tieredGwp.attr('data-tiered-gwp-all-delete') === 'remove' ? true : false;
          var clearTieredGWP = window.sessionStorage.getItem('clearTieredGWP');

          if (tieredGwpsAll && tieredGwpsAllDelete || !clearTieredGWP) {
            $.each(tieredGwpsAll, function(index, el) {
              if (el != '') {
                tieredGwpData[el] = 0;
              }
            });
            sessionStorage.setItem('clearTieredGWP', true);
          } else {
            if (tieredGwpId1 && tieredGwpAction1 !== false) tieredGwpData[tieredGwpId1] = tieredGwpAction1;
            if (tieredGwpId2_1 && tieredGwpAction2 !== false) tieredGwpData[tieredGwpId2_1] = tieredGwpAction2;
            if (tieredGwpId2_2 && tieredGwpAction2 !== false) tieredGwpData[tieredGwpId2_2] = tieredGwpAction2;
            if (tieredGwpId3_1 && tieredGwpAction3 !== false) tieredGwpData[tieredGwpId3_1] = tieredGwpAction3;
            if (tieredGwpId3_2 && tieredGwpAction3 !== false) tieredGwpData[tieredGwpId3_2] = tieredGwpAction3;
            if (tieredGwpId3_3 &&tieredGwpAction3 !== false) tieredGwpData[tieredGwpId3_3] = tieredGwpAction3;
          }

          if (Object.keys(tieredGwpData).length) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: tieredGwpData
              },
              dataType: 'json',
              success: function () {
                _this33.renderCart();
              }
            });
            return false;
          }

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: cartAttr,
            dataType: 'json',
            success: function (data) {
              // console.log(data);
            }
          });

          if (gwpSelectedProductsIdsInCart) {
            $.each(gwpSelectedProductsIdsInCart, function(index, el){
              gwpSelectedProductsIdData[el] = 0;
            });
          }

          var gwpSelectedUpdate = gwpSelectedProduct != undefined && gwpSelectedProduct.length && gwpSelectedEvent != undefined && gwpSelectedEvent.length;
          var gwpSelectedDelete = Object.keys(gwpSelectedProductsIdData).length >= 1 && gwpSelectedProductsDeleteAll;

          if (gwpSelectedUpdate || gwpSelectedDelete) {

            if (gwpSelectedUpdate) {
              gwpSelectedProductsIdData[gwpSelectedProduct] = 0;

              if (gwpSelectedEvent == 'add') {
                gwpSelectedProductsIdData[gwpSelectedProduct] = 1;
              }
            }

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: gwpSelectedProductsIdData
              },
              dataType: 'json',
              success: function () {
                _this33.renderCart();
                return false;
              }
            });
          } else {
            var $sideBarCart = $('#sidebar-cart');
            var $cartIndicator = $('.header__cart--indicator');
            
            $sideBarCart.html($(html).find('> *'));
            $cartIndicator.html(count);
  
            if (count && $cartIndicator.hasClass('hide')) {
              $cartIndicator.removeClass('hide')
            } else if (!count && !$cartIndicator.hasClass('hide')) {
              $cartIndicator.addClass('hide')
            }
  
            $('[data-cart-count]').html($('[data-count]').attr('data-count'));
  
            if (count) {
              $('.cart-count').fadeIn();
            } else {
              $('.cart-count').fadeOut();
            }
            
            if ($sideBarCart.attr('aria-hidden') == 'true') {
              _this33.openSidebar(evt);
            }

            if (layoutType) {
              $('#sidebar-cart .cart-recommended__wrapper[data-layout-type!="'+layoutType+'"]').remove();
            }

            if (typeof Afterpay !== 'undefined') {
              Afterpay.createPlacements({
                targetSelector: '.cart-afterpay',
                attributes: {
                  locale: Afterpay.locale.en_US,
                  currency: Afterpay.currency.USD,
                  amountSelector: '.cart-drawer__subtotal-price',
                  size: Afterpay.size.XS,
                  isEligible: true,
                  showUpperLimit: true,
                  showLowerLimit: true,
                  modalLinkStyle: Afterpay.modalLinkStyle.LEARN_MORE_TEXT,
                  modalTheme: Afterpay.theme.modal.WHITE,
                  badgeTheme: Afterpay.theme.badge.BLACK_ON_WHITE,
                  logoType: Afterpay.logoType.LOCKUP
                }
              });
            }


            var $slideshow = $('#sidebar-cart .cart-recommended');

            if ($slideshow.length) {
              var slideshowСonfig = $.parseJSON($slideshow.attr('data-slick-config'));
              var documentLayout = $('html').attr('data-layout');

              if (slideshowСonfig.arrows) {
                if (documentLayout === 'skin') {
                  slideshowСonfig["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>';
                  slideshowСonfig["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></button>';
                } else {
                  slideshowСonfig["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M3.979 27L18 13.5 3.979 0 0 3.831 10.045 13.5 0 23.169z" transform="translate(-1285 -338) translate(0 48) translate(408 290) translate(877) matrix(-1 0 0 1 18 0)"/></g></g></svg></button>';
                  slideshowСonfig["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M51.979 27L66 13.5 51.979 0 48 3.831 58.045 13.5 48 23.169z" transform="translate(-1333 -338) translate(0 48) translate(408 290) translate(877)"/></g></g></svg></button>';
                }
              }
  
              if (!$slideshow.hasClass('slick-initialized')) {
                $slideshow.slick(slideshowСonfig);
              }

              function customDot ($sliderDots) {
                if (!$sliderDots) {
                  return
                }

                if ($sliderDots.find('li:not(.custom-dot)').length < 2) {
                  $sliderDots.hide();
                }

                $sliderDots.parents('.slick-slider').slick('slickGoTo', 0);

                var activeDotsIndex = $sliderDots.find('.slick-active').index();
                var dotsLength = $sliderDots.find('li:not(.custom-dot)').length;
                var dotWidth = 100 / dotsLength;
                var dotLeft = (100 / dotsLength) * activeDotsIndex;

                if (!$sliderDots.find('.custom-dot').length) {
                  $sliderDots.append('<li class="custom-dot" style="width: '+ dotWidth +'%; left:'+ dotLeft +'%"></li>');
                }
              }

              customDot($slideshow.find('.slick-dots'));

              $slideshow.on('breakpoint', $.debounce(200, function(event, slick, breakpoint) {
                $slideshow.slick('slickGoTo', 0);

                customDot(slick.$dots);
              }));

              $slideshow.on('beforeChange', $.debounce(200, function(event, slick, currentSlide, nextSlide){
                var slickSpeed = slideshowСonfig.autoplay == true ? slideshowСonfig.autoplaySpeed : slideshowСonfig.speed;

                if (slick.$dots) {
                  var activeDotsIndex = slick.$dots.find('.slick-active').index();
                  var $customDot = slick.$dots.find('.custom-dot');
                  var dotsLength = slick.$dots.find('li:not(.custom-dot)').length;
                  var dotWidth = 100 / dotsLength;

                  if (currentSlide > nextSlide) {
                    $customDot.animate({
                      left: dotWidth * activeDotsIndex + '%',
                    }, slickSpeed)
                  } else {
                    $customDot.animate({
                      left: dotWidth * activeDotsIndex + '%',
                    }, slickSpeed)
                  }
                }
              }));
            }
          }
        });
      });
    },

    openSidebar: function (evt) {
      if (evt) {
        evt.preventDefault();
      }

      var $drawer = $('#sidebar-cart');
      var $closeBtn = $drawer.find('.close-cart-drawer')[0];
      var id = 'cart-sidebar';
      var $thisModal = $('#' + id);
      
      $drawer.attr('aria-hidden', false);
      bodyScrollLock.disableBodyScroll($drawer.find('.cart-drawer__main')[0]);

      if (!$thisModal) {
        return;
      }

      $thisModal.attr('aria-hidden', 'false');
      $('html, body').addClass('global_sidebar--open');

      document.documentElement.style.setProperty('--drawer-header-height', $('#sidebar-cart .cart-drawer__header').outerHeight() + 'px');
      $closeBtn.focus()

      var focusableSelectors = `
      a[href], button:not([disabled]),
      textarea, input:not([disabled]),
      select, [tabindex]:not([tabindex="-1"])
      `;

      var $focusable;
      var $lastEl
      var $lastElEmpty
      setTimeout(function() {
        $focusable = $drawer
          .find(focusableSelectors)
          .filter(':visible');
        $lastEl = $focusable.filter('.slick-next')[0];
        $lastElEmpty = $focusable.last()[0];
      }, 300);


      $drawer.on('keydown', function (e) {
        if (!$focusable || !$focusable.length) return; // guard

        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          _self.closeSidebar();
          return;
        }

        if (e.key === 'Tab') {
          if ($focusable.length === 0) return;
          if (e.shiftKey) {
            if (document.activeElement === $closeBtn) {
              e.preventDefault();
              $lastEl.focus();
            }
          } else {
            if (document.activeElement === $lastEl) {
              e.preventDefault();
              $closeBtn.focus()
            } else if (document.activeElement === $lastElEmpty) {
              e.preventDefault();
              $closeBtn.focus()
            }
          }
        }
      })
    },
    
    closeSidebar: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      var $drawer = $('#sidebar-cart');
  
      $drawer.attr('aria-hidden', 'true');
      $('html, body').removeClass('global_sidebar--open');
      bodyScrollLock.clearAllBodyScrollLocks();
      $('.header__cart').focus()
    },
    
    quickAddToCart: function (evt) {
      evt.preventDefault();
      
      var _self = this;
      
      var data = {
        id: evt.target.getAttribute('data-variant-id'),
        quantity: 1
      };
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function () {
        _self.renderCart();
      })
    },

    quickAddToCartFormSerialize: function (evt) {
      evt.preventDefault();

      var _self = this;

      var form = $(evt.target).closest('form');
      var form_array = form.serializeArray();

      if (form.find('[type="file"]').length){
        return;
      }

      var data = {};

      $.map(form_array, function(val) {
        data[val.name] = val.value;
      });

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function () {
        _self.renderCart();
      })
    },

    onProductAdded: function (evt) {
      this.renderCart(evt);
    },

    promoCodeTracking: function () {
      $(document).on('click', '.cart-drawer__discount--close', function () {
        var $promoCodeContainerInner = $(document).find('.cart-drawer__discount-inner');
        var $promoCodeBtnOpen = $(document).find('.cart-drawer__discount--open');

        $promoCodeContainerInner.hide();
        $promoCodeBtnOpen.show();
      });

      $(document).on('click', '.cart-drawer__discount--open', function () {
        var $promoCodeContainerInner = $(document).find('.cart-drawer__discount-inner');

        $promoCodeContainerInner.show();
        $(this).hide();
      });
    },

    clickGwpButtons: function () {
      var $modal = $('#gwp-modal-overlay');
      var _self = this;

      $(document).on('click', '[data-gwp-btn-close]', function (evt) {
        evt.preventDefault();

        if ($modal.find('.slick-initialized[data-slick-config]').length) {
          $.each($modal.find('.slick-initialized[data-slick-config]'), function (index, val) {
            $(val).slick('unslick');
          });
        }

        _self.renderCart();
        $('html, body').removeClass('modal--open');
        bodyScrollLock.clearAllBodyScrollLocks();
        $modal.attr('aria-hidden', false).fadeOut();
      });

      $(document).on('click', '[data-gwp-btn-open]', function (evt) {
        evt.preventDefault();
        var gwpProductsInCart = [];
        var gwpType = $(document).find('.Cart__FreeShipping[data-gwp-type]').attr('data-gwp-type');

        if ($modal.find('[data-slick-config]').length) {
          $.each($modal.find('[data-slick-config]'), function (index, val) {
            var $elem = $(val);
            if (!$elem.hasClass('slick-initialized')) {
              theme.Slideshow($elem);
            }
          });
        }

        $.ajax({
          async: false,
          method: 'GET',
          url: '/cart.js',
          dataType: 'json'
        }).done(function (response) {
          response.items.forEach(function (product) {
            if (product.product_type == "Free Gift") {
              gwpProductsInCart.push(product);
              window.currentGwpVariantIdInCart = product.id;
              return false;
            }
          });
        });

        if (gwpProductsInCart.length) {
          if (gwpType == 'variants') {
            $.each(gwpProductsInCart, function(index, el){
              $.each(el.options_with_values, function(indexOption, option){
                var $options = $('[data-options-id="'+ option.name + el.product_id + '"]');
                $options.find('[data-value="'+ option.value +'"]').trigger('click');
              });
            });
            $('.gwp-modal__back-to-cart').attr('disabled', false);
          } else if (gwpType == 'products') {

            $('.gwp-modal-products').find('[data-gwp-variant-id="'+ window.currentGwpVariantIdInCart +'"]').html(theme.strings.gwpAdded);
          }
        } else {
          $('.gwp-modal__back-to-cart').attr('disabled', true);
          window.currentGwpVariantIdInCart = null;
          $('[data-gwp-variant-add]:not([disabled])').html(theme.strings.gwpAdd);
        }

        _self.closeSidebar();
        $modal.attr('aria-hidden', true).fadeIn();
        $('html, body').addClass('modal--open');
        bodyScrollLock.disableBodyScroll($modal.find('.gwp-modal__inner')[0]);
      });

      $(document).on('mouseenter', '[data-gwp-btn-open]', function (evt) {
        evt.preventDefault();

        $(this).parents('.checkout__buttons').find('.cart-drawer__checkout:visible').addClass('hover');
      });

      $(document).on('mouseleave', '[data-gwp-btn-open]', function (evt) {
        evt.preventDefault();

        $(this).parents('.checkout__buttons').find('.cart-drawer__checkout:visible').removeClass('hover');
      });

      $(document).mouseup(function (e){
        var div = $modal.find('.gwp-modal');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && div.is(':visible')) {
          if ($modal.is(':visible')) {
            $('[data-gwp-btn-close]').trigger('click');
          }
        }
      });
    },
  
    subscriptionChange: function (evt) {
      const _self = this;
      const target = evt.target;
      const selectedPlan = $('option:selected', target);
      const sellingPlanId = selectedPlan.val();
      const index = selectedPlan.attr('data-index');
      const subscriptionGroupId = selectedPlan.attr('data-selling-plan-group-id');
      const qty = selectedPlan.attr('data-qty');
  
      const data = {
        line: index,
        quantity: qty,
        selling_plan: null
      };
  
      if(sellingPlanId !== 'one-time-purchase'){
        data['selling_plan'] = sellingPlanId;
        data['purchase_option'] = subscriptionGroupId;
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function () {
          _self.renderCart(evt);
        }
      });
    }
  });

  return Cart;
})();

theme.GwpModalProduct = (function() {

  var selectors = {
    originalSelectorId: '[data-product-select]',
    productFeaturedImage: '[data-product-featured-image]',
    productImageId: '[data-product-image-id]',
    productSlideshow: '[data-product-slideshow]',
    productJson: '[data-product-json]',
    singleOptionSelector: '[data-single-option-selector]',
    addToCart: '[data-gwp-variant-add]',
    backToCart: '.gwp-modal__back-to-cart'
  };

  function GwpModalProduct(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange', this.updateVariant.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange', this.updateProductImage.bind(this));
    }

    $(selectors.singleOptionSelector, this.$container).on('change', function (evt) {
      evt.stopPropagation();
    });

    this.changeOptionShadeColor();
    this.changeOption();
    this.addGwpToCart();
  }

  GwpModalProduct.prototype = $.extend({}, GwpModalProduct.prototype, {

    updateVariant: function (evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(selectors.addToCart).attr('data-gwp-variant-id', variant.id).attr('disabled', false).html(theme.strings.gwpAdd);

          if (variant.id == window.currentGwpVariantIdInCart) {
            $(selectors.addToCart).html(theme.strings.gwpAdded);
          }
        } else {
          $(selectors.addToCart).attr('data-gwp-variant-id', variant.id).attr('disabled', true).html(theme.strings.soldOut);
        }
      } else {
        $(selectors.addToCart).attr('data-gwp-variant-id', 'null').attr('disabled', true).html(theme.strings.soldOut);
      }
    },

    changeOptionShadeColor: function() {
      var $container = this.$container;

      $('.product-options-select__button', $container).on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
      });

      $(document).mouseup(function (e){
        var div = $('.product-options-select .product-options-select__list');
        var parentDiv = $('.product-options-select .product-options-select__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.product-options-select .product-options-select__inner').removeClass('active');
          $('.product-options-select .product-options-select__list').slideUp();
        }
      });

      $('.product-options-select__item', $container).on('click', function () {
        var value = $(this).attr('data-value');
        var $parent = $(this).parents('.product-options-select');
        var $input = $parent.prev().find(selectors.singleOptionSelector + '[value="'+ value +'"]');
        var $labelText = $parent.find('.product-options-select__label>div:first-child');
        var $content = $(this).html();

        $parent.find('.product-options-select__inner').removeClass('active');
        $parent.find('.product-options-select__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        $labelText.html($content);
        $input.trigger('click');
      });

      $('.product-options-swatch__btn', $container).on('click', function () {
        var $wrapper = $(this).parents('.product-options-swatch__wrapper');
        var $fieldset = $wrapper.find('.product-options-swatch-fieldset');

        $wrapper.toggleClass('collapse');

        if ($wrapper.hasClass('collapse')) {
          $(this).find('span:first-child').hide();
          $(this).find('span:nth-child(2)').fadeIn();
          $fieldset.find('h4').show().animate({width: "100%"}, 300, function () {
            $fieldset.find('h4').show()
          });
        } else {
          $(this).find('span:nth-child(2)').hide();
          $(this).find('span:first-child').fadeIn();
          $fieldset.find('h4').animate({width: "0%"}, 300, function () {
            $fieldset.find('h4').hide()
          });
        }
      });

      $(document).on('click', '.product-options-swatch__input' + selectors.singleOptionSelector, function () {
        $('.product-options-select__item[data-value="' + $(this).val() + '"]:not(.selected)').trigger('click');
      });
    },

    changeOption: function() {
      var $container = this.$container;

      $('.product-options__button', $container).on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
      });

      $(document).mouseup(function (e){
        var div = $('.product-options .product-options__list');
        var parentDiv = $('.product-options .product-options__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.product-options .product-options__inner').removeClass('active');
          $('.product-options .product-options__list').slideUp();
        }
      });

      $('.product-options__item', $container).on('click', function () {
        var value = $(this).attr('data-value');
        var $parent = $(this).parents('.product-options');
        var $input = $parent.find(selectors.singleOptionSelector);
        var $spanForValue = $parent.find('.product-options__value');

        $parent.find('.product-options__inner').removeClass('active');
        $parent.find('.product-options__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        $spanForValue.html(value);
        $input.val(value).trigger('change');
      });
    },

    updateProductImage: function(evt) {
      var variant = evt.variant;

      if (!variant) {
        return;
      }

      if (variant.featured_image){
        var imageId = variant.featured_image.id;
        var slideIndex = $('[data-product-image-id="'+imageId+'"]', this.$container).parents('.slick-slide').attr('data-slick-index');
        var productId = this.productSingleObject.id;

        $('[data-product-slideshow="'+ productId +'"]').slick('slickGoTo', slideIndex);
      }
    },

    addGwpToCart: function () {
      this.$container.find('[data-gwp-variant-add]').on('click', function () {
        var $thisButton = $(this);
        var id = $(this).attr('data-gwp-variant-id');
        var gwpProductsIdsInCart = [];
        var gwpProductsIdData = {};
        var gwpType = $(document).find('.Cart__FreeShipping[data-gwp-type]').attr('data-gwp-type');

        $.ajax({
          async: false,
          method: 'GET',
          url: '/cart.js',
          dataType: 'json'
        }).done(function (response) {
          response.items.forEach(function (product) {
            if (product.product_type == "Free Gift") {
              gwpProductsIdsInCart.push(product.id);
            }
          });
        });

        if (id == 'unavailable') {return false};

        if (gwpProductsIdsInCart.length) {
          $.each(gwpProductsIdsInCart, function(index, el){
            gwpProductsIdData[el] = 0;
          });
        } else {
          window.currentGwpVariantIdInCart = null;
        }

        $(selectors.backToCart).attr('disabled', false);
        window.currentGwpVariantIdInCart = id;
        gwpProductsIdData[id] = 1;

        $.ajax({
          async: false,
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: gwpProductsIdData
          },
          dataType: 'json'
        }).done(function () {
          if (gwpType == 'products') {
            $('[data-gwp-variant-add]:not([disabled])').html(theme.strings.gwpAdd);
            $(document).find('[data-gwp-btn-close]').trigger('click');
          }
          $thisButton.html(theme.strings.gwpAdded);
        });
      });
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return GwpModalProduct;
})();
theme.AccountInfo = (function () {

  function AccountInfo(container) {
    var $container = this.$container = $(container);
    var id = this.id = $container.attr('data-section-id');
    var formInput = $container.find('input');
    var btnSubmit = $container.find('button.btn');

    Accentuate(jQuery('#update-customer-info'), function(data) {
      if (data.status == 'ERROR') {
        $('#update-customer-info #email').addClass('error');
      } else if (data.status == 'OK') {
        location.reload();
      }
    });

    $(document.body).off('change', formInput);

    $(document.body).on('change keyup', formInput, function(event) {
      btnSubmit.attr('disabled', false);
    });
  }
  return AccountInfo;
})();


$(document).ready(function() {
  var sections = new slate.Sections();

  $(document).on('countryCodeSave', function () {
    sections.register('country-code-filter', theme.CountryCodeFilter);
  });

  if (sessionStorage.getItem("userCountryIsoCode")) {
    document.dispatchEvent(new CustomEvent('countryCodeSave'));
  } else {
    fetch("https://api.geoapify.com/v1/ipinfo?apiKey=f77d5b7efbe94005857f140fc7d67cce", {
      method: 'GET',
    })
      .then(resp => resp.json())
      .then((geocodingResult) => {
        if (geocodingResult.statusCode >= 200 && geocodingResult.statusCode <= 299 || !geocodingResult.statusCode) {
          const userCountryIsoCode = geocodingResult.country['iso_code'];
          sessionStorage.setItem('userCountryIsoCode', userCountryIsoCode);
          document.dispatchEvent(new CustomEvent('countryCodeSave'));
        } else {
          return Promise.reject(geocodingResult);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  sections.register('cart', theme.Cart);

// Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

$(document).on('blur', 'input, textarea', function  () {
  var isApple = ['iPhone', 'iPad', 'iPod', 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator',].includes(navigator.platform);

  if ($('html').hasClass('global_sidebar--open') && isApple) {
    setTimeout(function () {
      $('html,body').animate({
        scrollTop: 0
      }, 0);
    }, 0);
  }
})

$(window).on('load', function() {
  var showAnimations = $('body').data('animations');
  // if ($('.preloader').length) {
  //   $('.preloader').fadeOut('100');
  // }
  if (showAnimations && window.AOS) {
    AOS.init({once: true});
    $('body').addClass('aos-initialized');
  }
});